/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext } from "react";
export const FormContext = createContext({});
/**
 * Provide the form api and state to underlying components. Must be used together with `useForm()`.
 */
function FormProvider({ form, state, children }) {
    return (React.createElement(FormContext.Provider, { value: { form, state } }, children));
}
export default FormProvider;
